<template>
<fragment>
    <el-col >
        <div style="margin-top:64px;">
            <!-- 分隔性別&年齡選項 -->
        </div>
    </el-col>

    <el-col :xs="24" :sm="11" :md="11"  style="">
        <el-select v-model="lowerBound" placeholder="請選擇年齡下限" class="guide_select" @change="chooseLowerBound">
            <el-option
                    v-for="item in age_from_option"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
        </el-select>
    </el-col>
    <el-col :xs="24" :sm="2" :md="2">
        <span class="guide_select_text" style="">  至 </span>
    </el-col>
    <el-col :xs="24" :sm="11" :md="11" style="">
        <el-select v-model="upperBound" placeholder="請選擇年齡上限" class="guide_select" @change="chooseHigherBound">
            <el-option
                    v-for="item in age_to_option"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled">
            </el-option>
        </el-select>
    </el-col>
</fragment>
</template>

<script>
export default {
  name: 'AgePicker',
  props: ['initLowerBound', 'initUpperBound'],
  data () {
    return {
      lowerBound: this.initLowerBound,
      upperBound: this.initUpperBound,
      age_from_option: [
        { value: 18, label: '18歲', disabled: false },
        { value: 25, label: '25歲', disabled: false },
        { value: 35, label: '35歲', disabled: false },
        { value: 45, label: '45歲', disabled: false },
        { value: 55, label: '55歲', disabled: false }
      ],
      age_to_option: [
        { value: 24, label: '24歲', disabled: false },
        { value: 34, label: '34歲', disabled: false },
        { value: 44, label: '44歲', disabled: false },
        { value: 54, label: '54歲', disabled: false },
        { value: '55+', label: '55歲以上', disabled: false }
      ]
    }
  },
  methods: {
    chooseLowerBound (val) {
      this.age_to_option.map((option) => {
        option.disabled = option.value < this.lowerBound
      })

      this.lowerBound = val
      this.upperBound = ''
      this.updateChange()
    },
    chooseHigherBound (val) {
      this.upperBound = val
      this.updateChange()
    },
    updateChange () {
      this.$emit('change', [this.lowerBound, this.upperBound])
    }
  }
}
</script>

<style>
    .el-input_inner.guide_input{
        text-align: center;
        background: transparent;
        border-width: 0 0 1px 0;
        border-radius: 0;
        font-size: 24px;
    }
    .guide_select.el-select{
        width:100%;
    }
    .guide_select.el-select .el-input__inner{
        height:80px;
        text-align:center;
        display:flex;
        align-items: center;
        border:2px solid #fff;
        background-color: #ffffff;
        box-shadow: 0 4px 10px 0 rgba(199, 199, 199, 0.5);
        font-size:16px;

    }
    .guide_select.el-select .el-input .el-select__caret{
        font-size:24px;
        margin-right: 16px;
    }
    .guide_select_text{
        text-align:center;
        display:block;
        height:80px;
        line-height:80px;
    }
</style>
